<style>
  /* Icona galleria */
  .gallery-icon-wrapper {
    width: 100%;
    text-align: center;
  }

  .gallery-icon-wrapper .icon-circle {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
  }

  .gallery-icon-wrapper .icon-circle:hover {
    transform: scale(1.05) rotate(5deg);
    box-shadow: 0 15px 40px rgba(102, 126, 234, 0.4) !important;
  }

  /* Container galleria */
  .gallery-container {
    position: relative;
  }

  .gallery-container .form-overlay {
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 1;
    border-radius: 24px;
  }

  /* Grid galleria */
  .gallery-grid {
    position: relative;
    z-index: 2;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 1.5rem;
    padding: 1rem 0;
  }

  /* Item galleria */
  .gallery-item-wrapper {
    perspective: 1000px;
  }

  .gallery-item {
    position: relative;
    width: 100%;
    aspect-ratio: 1;
    border-radius: 16px;
    overflow: hidden;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(15px);
    border: 1px solid rgba(102, 126, 234, 0.3);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .gallery-item:hover {
    transform: translateY(-8px) scale(1.02);
    box-shadow: 0 15px 40px rgba(102, 126, 234, 0.25);
    border-color: rgba(102, 126, 234, 0.5);
  }

  /* Immagine e video */
  .gallery-image,
  .gallery-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }

  .gallery-item:hover .gallery-image,
  .gallery-item:hover .gallery-video {
    transform: scale(1.05);
  }

  /* Overlay video */
  .video-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.4);
    transition: all 0.3s ease;
    z-index: 2;
  }

  .gallery-item:hover .video-overlay {
    background: rgba(0, 0, 0, 0.6);
  }

  /* Info item */
  .gallery-item-info {
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, transparent 50%, rgba(0, 0, 0, 0.8));
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 1.5rem;
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: 3;
  }

  .gallery-item:hover .gallery-item-info {
    opacity: 1;
  }

  .gallery-title {
    color: white;
    font-weight: 600;
    margin: 0;
    font-size: 1rem;
  }

  .gallery-icon {
    color: #667eea;
    font-size: 1.2rem;
    margin-top: 0.5rem;
  }

  /* Lightbox */
  .lightbox-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.85);
    z-index: 9999;
    animation: fadeIn 0.4s ease;
    backdrop-filter: blur(8px);
    /* NESSUN padding, NESSUN border-radius */
  }

  .lightbox-container {
    position: absolute;
    inset: 1rem; /* Padding uguale su tutti i lati */
    max-width: calc(100vw - 2rem);
    max-height: calc(100vh - 2rem);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    animation: zoomIn 0.4s ease;
    /* Border-radius solo qui */
    border-radius: 12px;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(10px);
  }

  .lightbox-content {
    position: relative;
    width: 100%;
    max-width: 100%;
    max-height: 85vh;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(20px);
    box-shadow: 0 25px 60px rgba(0, 0, 0, 0.4);
  }

  .lightbox-image,
  .lightbox-video {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 85vh;
    object-fit: contain;
    border-radius: 12px;
  }

  .lightbox-title {
    color: rgba(255, 255, 255, 0.95);
    text-align: center;
    margin-top: 1.5rem;
    font-weight: 600;
    font-size: clamp(1rem, 2.5vw, 1.25rem);
    padding: 0 1rem;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
  }

  .lightbox-title h4 {
    margin: 0;
  }

  /* Pulsante chiudi migliorato */
  .lightbox-close {
    position: absolute;
    top: 1rem;
    right: clamp(0.75rem, 2vw, 1.25rem);
    width: clamp(44px, 8vw, 52px);
    height: clamp(44px, 8vw, 52px);
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: white;
    font-size: clamp(1.2rem, 4vw, 1.5rem);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 10000;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  }

  .lightbox-close:hover {
    background: rgba(255, 255, 255, 0.25);
    transform: scale(1.1) rotate(90deg);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4);
  }

  .lightbox-close:active {
    transform: scale(0.95) rotate(90deg);
  }

  /* Navigazione migliorata */
  .lightbox-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: clamp(48px, 10vw, 60px);
    height: clamp(48px, 10vw, 60px);
    border-radius: 50%;
    background: rgba(102, 126, 234, 0.9);
    backdrop-filter: blur(15px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: white;
    font-size: clamp(1rem, 3vw, 1.3rem);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 10000;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  }

  .lightbox-nav:hover {
    background: rgba(102, 126, 234, 1);
    transform: translateY(-50%) scale(1.15);
    box-shadow: 0 12px 35px rgba(102, 126, 234, 0.4);
  }

  .lightbox-nav:active {
    transform: translateY(-50%) scale(0.95);
  }

  .lightbox-prev {
    left: clamp(0.75rem, 2vw, 1.25rem);
  }

  .lightbox-next {
    right: clamp(0.75rem, 2vw, 1.25rem);
  }

  /* Empty state */
  .empty-state-icon {
    opacity: 0.5;
  }

  /* Animazioni fluide */
  @keyframes fadeIn {
    from {
      opacity: 0;
      backdrop-filter: blur(0px);
    }
    to {
      opacity: 1;
      backdrop-filter: blur(8px) saturate(0.8);
    }
  }

  @keyframes zoomIn {
    from {
      transform: scale(0.85) translateY(20px);
      opacity: 0;
    }
    to {
      transform: scale(1) translateY(0);
      opacity: 1;
    }
  }

  /* Responsive generale */
  @media (max-width: 768px) {
    .gallery-grid {
      grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
      gap: 1rem;
    }

    .gallery-icon-wrapper .icon-circle {
      width: 70px;
      height: 70px;
    }

    /* Responsive lightbox specifico */
    .lightbox-overlay {
      padding: 0.5rem;
    }

    .lightbox-container {
      max-width: 98vw;
      max-height: 98vh;
    }

    .lightbox-content {
      border-radius: 8px;
      max-height: 75vh;
    }

    .lightbox-image,
    .lightbox-video {
      max-height: 75vh;
      border-radius: 8px;
    }

    .lightbox-close {
      top: 0.75rem;
      right: 0.75rem;
    }
  }

  /* Tablet */
  @media (max-width: 1024px) {
    .lightbox-content {
      max-height: 90vh;
    }

    .lightbox-image,
    .lightbox-video {
      max-height: 90vh;
    }
  }

  /* Nascondi nav su schermi molto piccoli */
  @media (max-width: 480px) {
    .lightbox-nav {
      display: none;
    }

    .lightbox-container {
      max-width: 99vw;
      max-height: 99vh;
    }

    .lightbox-content {
      max-height: 70vh;
      border-radius: 4px;
    }

    .lightbox-image,
    .lightbox-video {
      max-height: 70vh;
      border-radius: 4px;
    }

    .lightbox-title {
      margin-top: 1rem;
      padding: 0 0.5rem;
    }
  }
</style>

<!-- GALLERIA - Uniforme al calendario -->
<div class="d-flex justify-content-center align-items-center mb-4 position-relative">
  <!-- Icona grande centrata -->
  <div class="gallery-icon-wrapper">
    <div class="icon-circle bg-primary bg-gradient shadow-lg">
      <i class="fas fa-camera fa-2x text-white"></i>
    </div>
  </div>
</div>

<!-- Loading -->
@if (loading) {
  <div class="text-center py-5">
    <div
      class="spinner-border spinner-border-lg text-primary shadow-lg"
      style="width: 4rem; height: 4rem"
    ></div>
    <p class="mt-3 text-muted fw-medium">Caricamento galleria...</p>
  </div>
}

<!-- Galleria -->
@if (!loading && galleryItems.length > 0) {
  <div class="gallery-container position-relative">
    <div class="form-overlay"></div>

    <div class="gallery-grid">
      @for (item of galleryItems; track item.id) {
        <div class="gallery-item-wrapper">
          <div
            class="gallery-item"
            [class.video-item]="item.type === 'video'"
            (click)="openLightbox(item)"
          >
            @if (item.type === 'image') {
              <img [src]="item.path" [alt]="item.title" class="gallery-image" />
            } @else {
              <video class="gallery-video" [poster]="item.thumbnail">
                <source [src]="item.path" type="video/mp4" />
              </video>
              <div class="video-overlay">
                <i class="fas fa-play fa-2x text-white"></i>
              </div>
            }

            <div class="gallery-item-info">
              <h5 class="gallery-title">{{ item.title }}</h5>
              <div class="gallery-icon">
                <i [class]="item.type === 'image' ? 'fas fa-image' : 'fas fa-video'"></i>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}

<!-- Lightbox MIGLIORATO -->
@if (showLightbox && selectedItem) {
  <div class="lightbox-overlay" (click)="closeLightbox()">
    <div class="lightbox-container" (click)="$event.stopPropagation()">
      <!-- Chiudi -->
      <button class="lightbox-close" (click)="closeLightbox()">
        <i class="fas fa-times"></i>
      </button>

      <!-- Contenuto -->
      <div class="lightbox-content">
        @if (selectedItem.type === 'image') {
          <img [src]="selectedItem.path" [alt]="selectedItem.title" class="lightbox-image" />
        } @else {
          <video controls class="lightbox-video">
            <source [src]="selectedItem.path" type="video/mp4" />
          </video>
        }
      </div>

      <!-- Titolo -->
      <div class="lightbox-title">
        <h4>{{ selectedItem.title }}</h4>
      </div>

      <!-- Navigazione (nascosta su mobile piccolo) -->
      <button class="lightbox-nav lightbox-prev" (click)="navigatePrevious()">
        <i class="fas fa-chevron-left"></i>
      </button>
      <button class="lightbox-nav lightbox-next" (click)="navigateNext()">
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>
  </div>
}

<!-- Empty state -->
@if (!loading && galleryItems.length === 0) {
  <div class="text-center py-5">
    <div class="empty-state-icon mb-3">
      <i class="fas fa-image fa-3x text-muted"></i>
    </div>
    <p class="text-muted fw-medium">Nessun elemento nella galleria</p>
  </div>
}
